import Tab from "components/Tab";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsBackend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-backend-and-api.mdx";
import HowToCaptureAnonymousEventsIOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-ios.mdx";
import HowToCaptureAnonymousEventsWeb from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-web.mdx";
import HowToCaptureAnonymousEventsAndroid from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-android.mdx";
import HowToCaptureAnonymousEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-flutter.mdx";
import HowToCaptureIdentifiedEventsFrontend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-frontend.mdx";
import HowToCaptureIdentifiedEventsBackend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-backend.mdx";
import HowToCaptureIdentifiedEventsAndroid from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-android.mdx";
import HowToCaptureIdentifiedEventsiOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-ios.mdx";
import HowToCaptureIdentifiedEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-flutter.mdx";
import JSIdentifyWhenToCall from "../../../../contents/docs/_snippets/identify-when-to-call.mdx";
import JSIdentifyUseUniqueIds from "../../../../contents/docs/_snippets/identify-use-unique-ids.mdx";
import JSIdentifySetUserProperties from "../../../../contents/docs/_snippets/identify-setting-user-properties.mdx";
import * as React from 'react';
export default {
  Tab,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsBackend,
  HowToCaptureAnonymousEventsIOS,
  HowToCaptureAnonymousEventsWeb,
  HowToCaptureAnonymousEventsAndroid,
  HowToCaptureAnonymousEventsFlutter,
  HowToCaptureIdentifiedEventsFrontend,
  HowToCaptureIdentifiedEventsBackend,
  HowToCaptureIdentifiedEventsAndroid,
  HowToCaptureIdentifiedEventsiOS,
  HowToCaptureIdentifiedEventsFlutter,
  JSIdentifyWhenToCall,
  JSIdentifyUseUniqueIds,
  JSIdentifySetUserProperties,
  React
};